import { ACTIVITY_SECTIONS } from 'constants/enums'

export const ASSESSMENT_SIGNOFF = 'fo/assessor/ASSESSMENT_SIGNOFF'
export const ASSESSMENT_SIGNOFF_SUCCESS = `${ASSESSMENT_SIGNOFF}_SUCCESS`
export const ASSESSMENT_SIGNOFF_FAIL = `${ASSESSMENT_SIGNOFF}_FAIL`

const initialState = {
  isLoading: false
}

export default (state = initialState, action) => {
  switch (action) {
    case ASSESSMENT_SIGNOFF:
      return { isLoading: true }
    case ASSESSMENT_SIGNOFF_FAIL:
    case ASSESSMENT_SIGNOFF_SUCCESS:
      return { isLoading: false }
    default:
      return state
  }
}

export const assessmentSignOff = (id, activitySection, data) => {
  let url

  switch (activitySection) {
    case ACTIVITY_SECTIONS.adventurous_journey.id:
      url = `api/aj-participant-events/${id}/assessor-reports`

      break
    case ACTIVITY_SECTIONS.residential_project.id:
      url = `api/residential-projects/${id}/assessor-reports`
      break
    default:
      url = `api/activities/${id}/assessor-reports`
  }

  return {
    types: [
      ASSESSMENT_SIGNOFF,
      ASSESSMENT_SIGNOFF_SUCCESS,
      ASSESSMENT_SIGNOFF_FAIL
    ],
    promise: client => client.post(url, { data })
  }
}
